<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left"></div>
      <div class="nav-title d-allcenter overflow">校外人员场馆预约</div>
      <div class="nav-right"></div>
    </div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="待支付" name="second"></el-tab-pane>
        <el-tab-pane label="退款" name="third"></el-tab-pane>
        <el-tab-pane label="已完成" name="fourth"></el-tab-pane>
      </el-tabs>

      <div class="all-box">
        <div class="each-box" v-for="(item, index) in 8" :key="'box_' + item + index">
          <div class="d-between">
            <div style="width: 56px; height: 56px" class="d-allcenter">
              <el-image
                style="width: 56px; height: 56px"
                :src="require('@/assets/img/appointment/demo.png')"
                fit="cover"
              ></el-image>
              <!-- <img src="@/assets/img/appointment/demo.png" style="width: 100%" /> -->
            </div>
            <div class="d-column" style="width: calc(100% - 70px)">
              <div class="d-between" style="height: 32px">
                <div style="width: calc(100% - 62px)">网球场项目1网球场项目1</div>
                <div>￥<span class="weight">30</span></div>
              </div>
              <div class="d-between grey" style="margin-top: 8px">
                <div>2023/02/02 8:30-9:00</div>
                <div>待支付</div>
              </div>
            </div>
          </div>
          <div class="d-end" style="margin-top: 8px; flex-direction: row-reverse">
            <el-button size="small" class="full-btn">去支付</el-button>
            <el-button size="small" class="plain-btn">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bar d-around">
      <div class="d-column d-aligncnter">
        <img src="@/assets/img/appointment/home-grey.svg" />
        <div class="grey">主页</div>
      </div>
      <div class="d-column d-aligncnter">
        <img src="@/assets/img/appointment/shopping-active.svg" />
        <div class="green">我的预约</div>
      </div>
      <div class="d-column d-aligncnter">
        <img src="@/assets/img/appointment/setting-grey.svg" />
        <div class="grey">账号设置</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log('eee:', tab, event)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.model {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 2.801px 8.403px 31.122px -4.046px rgba(22, 52, 80, 0.1);
  margin-top: 16px;
  color: #464646;
}
.mt-16 {
  margin-top: 16px;
}
.venues-each {
  width: 347px;
  height: 192px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  margin: 8px;
  .bg-color {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #002417 0.15%, rgba(0, 122, 77, 0) 54.73%);
  }
  img {
    width: 100%;
  }
}
.venues-info {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}
.content {
  background: #f9f9f9;
}
.content ::v-deep .el-tabs__item.is-active {
  color: #2f2f2f !important;
  font-weight: 700;
  font-size: 18px;
}
.content ::v-deep .el-tabs__item {
  color: #8b8b8b;
}
.content ::v-deep .el-tabs__active-bar {
  background-color: #1a875f;
}
.all-box {
  height: calc(100vh - 220px);
  overflow: auto;
}
.each-box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  padding: 16px;
  color: #2f2f2f;
  font-size: 14px;
  margin-top: 16px;
}
.plain-btn {
  border: 1px solid #007a4d;
  color: #007a4d;
  margin: 0 4px;
}
.full-btn {
  background-color: #007a4d;
  color: #fff;
  border: 1px solid #007a4d;
  margin: 0 4px;
}
</style>
